export enum ReportAction {
    Share = 1,
    Unshare
}